import React, { useContext } from "react";
import { CartContext } from "../context/CartContext";

const ProductCard = ({ product }) => {
  const { addToCart } = useContext(CartContext);

  return (
    <div className="border rounded-lg shadow-md p-4 text-center hover:shadow-lg transition">
      <img
        src={product.image}
        alt={product.name}
        className="h-40 w-full object-contain mb-3"
      />
      <h3 className="font-semibold text-lg">{product.name}</h3>
      <p className="text-gray-500 text-sm">{product.category}</p>
      <p className="text-amber-600 font-bold mt-1">${product.price}</p>
      <button
        onClick={() => addToCart(product)}
        className="mt-3 bg-amber-500 text-white px-4 py-2 rounded-md hover:bg-amber-600"
      >
        Add to Cart
      </button>
    </div>
  );
};

export default ProductCard;
